import React, { useCallback, useState } from 'react'
import cx from 'classnames'
import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { l } from '@manychat/manyui'

import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader/SidebarHeader'
import { PreparingDataLoader } from 'apps/aiAutomation/components/TovSetup/components/PreparingDataLoader/PreparingDataLoader'
import { Progress } from 'apps/aiAutomation/components/TovSetup/components/Progress/Progress'
import { Questionnaire } from 'apps/aiAutomation/components/TovSetup/components/Questionnaire/Questionnaire'
import { SuccessTuning } from 'apps/aiAutomation/components/TovSetup/components/SuccessTuning/SuccessTuning'
import {
  AiAlwaysOnAutomationsActions,
  AiAlwaysOnAutomationsSelectors,
} from 'apps/aiAutomation/store/core'
import { AiAutomationTovState } from 'shared/api/requests/aiAutomation/schemas'
import { TovReaction } from 'shared/api/requests/aiToneOfVoice/schemas'

import cm from './TovSetup.module.css'

export const TovSetup = () => {
  const dispatch = useAppDispatch()

  const tovState = useAppSelector(AiAlwaysOnAutomationsSelectors.getTovState)
  const samples = useAppSelector(AiAlwaysOnAutomationsSelectors.getTovSamples)

  const [isSendingAnswers, setIsSendingAnswers] = useState(false)
  const [answeredSamples, setCompletedSamples] = useState(0)

  const sendAnswers = useCallback(
    async (answers: TovReaction[]) => {
      try {
        setIsSendingAnswers(true)

        await dispatch(AiAlwaysOnAutomationsActions.saveUserTovReactionFx(answers))
      } finally {
        setIsSendingAnswers(false)
      }
    },
    [dispatch],
  )

  return (
    <section className={cm.wrapper}>
      <SidebarHeader
        className={cx(tovState === AiAutomationTovState.WAITING_USER_REACTION && 'p-b-0 b-b-0')}
        title={
          tovState === AiAutomationTovState.ACTIVE
            ? l.translate('Nice Comment Responder')
            : l.translate('Set AI’s tone')
        }
      >
        {tovState === AiAutomationTovState.WAITING_USER_REACTION && samples.length > 0 && (
          <Progress current={answeredSamples} total={samples.length} />
        )}
      </SidebarHeader>

      <div className="o-auto p-y-md p-x">
        {(!tovState ||
          tovState === AiAutomationTovState.GENERATION_IN_PROGRESS ||
          isSendingAnswers) && (
          <PreparingDataLoader
            message={
              isSendingAnswers
                ? l.translate('Fine-tuning AI with your feedback…')
                : l.translate('AI is picking up your tone from Instagram…')
            }
          />
        )}

        {tovState === AiAutomationTovState.WAITING_USER_REACTION && !isSendingAnswers && (
          <Questionnaire onFinish={sendAnswers} onProgress={setCompletedSamples} />
        )}

        {tovState === AiAutomationTovState.ACTIVE && <SuccessTuning />}
      </div>
    </section>
  )
}
